/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NewChatIcon = /*#__PURE__*/ createSvgIcon(
  'NewChatIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.25 9.25v2c0 .213.071.39.214.534a.72.72 0 00.532.216c.21 0 .39-.072.535-.216a.72.72 0 00.219-.534v-2h2c.213 0 .39-.071.534-.214a.72.72 0 00.216-.532.734.734 0 00-.216-.535.72.72 0 00-.534-.219h-2v-2a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v2h-2a.728.728 0 00-.534.214.72.72 0 00-.216.532c0 .21.072.39.216.535a.72.72 0 00.534.219h2zM5 15l-1.727 1.727c-.237.237-.51.291-.815.16-.305-.13-.458-.364-.458-.7V3.5c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44H5zm-.625-1.5H16.5v-10h-13v10.875l.875-.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default NewChatIcon;
